"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FooterCell = _interopRequireDefault(require("./FooterCell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Footer(props) {
  var columns = props.columns,
      footer = props.footer;
  if (!footer) return null;
  return /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", {
    role: "row"
  }, columns.map(function (column) {
    return /*#__PURE__*/_react.default.createElement(_FooterCell.default, {
      column: column,
      data: footer,
      item: footer[column.key]
    });
  })));
}

Footer.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    width: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    minWidth: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    hidden: _propTypes.default.bool,
    sortable: _propTypes.default.bool,
    className: _propTypes.default.string
  })),
  footer: _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func])))
};
Footer.defaultProps = {
  columns: [],
  footer: null
};
var _default = Footer;
exports.default = _default;